import { Routes } from '@angular/router';
import { AppRoutes } from './consts/routes.consts';

export const routes: Routes = [
  {
    path: AppRoutes.ROOT,
    loadChildren: () => import('./early-check-in/early-check-in.routes').then((m) => m.routes),
  }
];
